import { render } from "./UefaAbout.vue?vue&type=template&id=f88299b4"
import script from "./UefaAbout.vue?vue&type=script&lang=js"
export * from "./UefaAbout.vue?vue&type=script&lang=js"

import "./UefaAbout.vue?vue&type=style&index=0&id=f88299b4&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__